import React, { useState, useRef, useEffect } from 'react'

import RepeatOptions from '../RepeatOptions'
import RepeatOccurrenceArrow from '../RepeatOccurrenceArrow'
import {
  REPEAT_BOOKING,
  CALENDAR_UNIT_EN,
  CALENDAR_UNIT_TH,
} from '../../../../helpers'

import { IMG } from '../../../../themes'

import { StylesRepeatEvery } from './styles'

const RepeatEvery = (props) => {
  const {
    language,
    repeatEveryType,
    repeatEveryOccurrence: occurrence,
    onSelectedRepeatEveryType,
    onSelectedRepeatEveryOccurrence,
    setDefaultWeekView,
    colorTheme,
  } = props

  const wrapperRef = useRef(null)

  const CALENDAR_UNIT = language === 'EN' ? CALENDAR_UNIT_EN : CALENDAR_UNIT_TH
  const defaultCalendarUnitIndex = CALENDAR_UNIT.findIndex(({ key }) => key === repeatEveryType)
  
  const [selectedCalendarUnitIndex, setSelectedCalendarUnitIndex] = useState(defaultCalendarUnitIndex)
  const [isOpenDropdown, setIsOpenDropdown] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorClassName, setErrorClassName] = useState('')

  const onSelectedCalendarUnit = (key, currentIndex) => {
    if (key === 'week') {
      setDefaultWeekView()
    }

    setSelectedCalendarUnitIndex(currentIndex)
    setIsOpenDropdown(false)
    onSelectedRepeatEveryType(key)
  }

  const onCloseDropdown = () => {
    setIsOpenDropdown(false)
  }

  const handleSelectedOccurrence = (_occurrence) => {
    onSelectedRepeatEveryOccurrence(_occurrence)
  }

  const clearError = () => {
    setErrorMessage('')
    setErrorClassName('')
  }

  const handleInputChange = (text, language) => {
    if (/^[0-9]*$/.test(text)) {
      handleSelectedOccurrence(text)
    }

    if (Number(text) > 0) {
      clearError()
    } else {
      setErrorMessage(REPEAT_BOOKING.OCCURRENCES_ERROR[language])
      setErrorClassName('box-error')
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpenDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [setIsOpenDropdown])

  useEffect(() => {
    if (Number(occurrence) > 0) {
      clearError()
    }
  }, [occurrence])

  return (
    <StylesRepeatEvery colorTheme={colorTheme}>
      <div className='layout'>
        <label className='title'>{REPEAT_BOOKING.EVERY[language]}</label>

        <div className='repeat-every-layout'>
          <input
            className={`repeat-every-input repeat-every-input-box ${errorClassName}`}
            value={`${occurrence}`}
            maxLength={2}
            onChange={(e) => handleInputChange(e.target.value, language)}
          />

          <RepeatOccurrenceArrow
            occurrence={occurrence}
            setOccurrence={handleSelectedOccurrence}
            isDisabled={false}
          />
        </div>

        <div className='dropdown-container' ref={wrapperRef}>
          <div
            className={isOpenDropdown ? 'dropdown-active-layout' : 'dropdown-layout'}
            onClick={() => setIsOpenDropdown(!isOpenDropdown)}
          >
            <label className='selected-option'>
              {CALENDAR_UNIT[selectedCalendarUnitIndex].value}
            </label>
        
            <img
              className={!isOpenDropdown ? 'arrow-down' : ''}
              src={IMG['chevron_up.svg']}
              alt='arrow'
            />
          </div>

          {
            isOpenDropdown && (
              <div className='option-layout'>
                <RepeatOptions
                  list={CALENDAR_UNIT}
                  selectedIndex={selectedCalendarUnitIndex}
                  onSelected={onSelectedCalendarUnit}
                  onClose={onCloseDropdown}
                  colorTheme={colorTheme}
                />
              </div>
            )
          }
        
        </div>
      </div>

      {errorMessage && <label className='error-message'>{errorMessage}</label> }

    </StylesRepeatEvery>
  )
}

export default RepeatEvery
